import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { successMessage } from "../../../utils/alertMessage";
import { InputText } from "primereact/inputtext";
import { Calendar } from "primereact/calendar";
import { useEffect } from "react";

export default function DataLimit() {
  const navigate = useNavigate();

  const [dataLimit, setDataLimit] = useState(
    "100"
  );

  
  let initialStartDate = new Date();
  initialStartDate.setDate(initialStartDate.getDate() - 90);

   
  const [startDateValue, setStartDateValue] = useState(initialStartDate);
  const [endDateValue, setEndDateValue] = useState(new Date());

  const handleSubmit = (e) => {
    e.preventDefault();

    localStorage.setItem("dataLimit", dataLimit);
    localStorage.setItem(
      "startDateFilter",
      startDateValue.toISOString()
    );

    localStorage.setItem(
      "endDateFilter",
      endDateValue.toISOString()
    );

    successMessage("Data Limit Saved Successfully");
    navigate(-1); // go back
  };

  
  useEffect(() => {

    const savedStartDate = localStorage.getItem("startDateFilter");
    const savedEndDate = localStorage.getItem("endDateFilter");

    setDataLimit(localStorage.getItem("dataLimit") || "100")
    setStartDateValue(savedStartDate ? new Date(savedStartDate) : initialStartDate);
    setEndDateValue(savedEndDate ? new Date(savedEndDate) : new Date());

  }, [])
  


  return (
    <main id="main" className="main">
      <section className="section main-color">
        <div className="row">
          <div className="col-lg-12">
            <div className="card-main">
              <div className="card-body">
                <h5 className="card-title flex">
                  <div
                    className="mr-3 cursor-pointer"
                    onClick={() => navigate(-1)}
                  >
                    <i className="bi bi-arrow-left-circle-fill"></i>
                  </div>
                  Data Limit Settings
                </h5>

                <form onSubmit={handleSubmit}>
                  <div className="row mb-3">
                    <div className="col-md-12">
                      <label className="form-label">
                        Default Data Limit
                      </label>

                      <InputText
                        type="number"
                        value={dataLimit}
                        style={{ width: "100%" }}
                        onChange={(e) => setDataLimit(e.target.value)}
                        placeholder="Enter Data Limit"
                      />
                    </div>
                  </div>

                  {(startDateValue && endDateValue) &&
                     <div className="row">
                    <div className="col-md mb-2">
                      <Calendar
                        value={startDateValue}
                        onChange={(e) => {
                          const start = e.value;
                          setStartDateValue(start);

                          if (!endDateValue) {
                            setEndDateValue(new Date()); // default today
                          }
                        }}
                        dateFormat="dd/mm/yy"
                        placeholder="Start Date"
                        maxDate={endDateValue ? endDateValue : new Date()}
                        showIcon
                        style={{ width: "100%" }}
                      />
                    </div>
                    <div className="col-md mb-2">
                      <Calendar
                        value={endDateValue}
                        onChange={(e) => setEndDateValue(e.value)}
                        dateFormat="dd/mm/yy"
                        placeholder="End Date"
                        minDate={startDateValue}
                        maxDate={new Date()}
                        showIcon
                        style={{ width: "100%" }} />
                    </div>
                  </div>}

                  <div className="col-md-12 text-center">
                    <button
                      type="submit"
                      className="move-btn move-btn-blue"
                    >
                      Save
                    </button>
                  </div>
                </form>

              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}